module.exports = __webpack_public_path__ + "img/spec.2c02a2b3.png";